import { toast } from "react-toastify";
import { FaPlay, FaPause } from "react-icons/fa6";
import PlayAudioPopUp from "../../../components/shared/PlayAudioPopUp";

async function handlePlayAudio(
    isPlay,
    setIsPlay,
    selectedAudio,
    toastId,
    audioRef,
    audioContainer,
    skipToast = false,
    setIsPopupClosedByUser = () => {},
    closedByScroll
) {
    if (isPlay) {
        async function increaseView() {
            try {
                await fetch(`/api/audios?aid=${selectedAudio.id}`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                });
            } catch (error) {
                console.error(error);
            }
        }
        increaseView();
        audioRef.current.play();

        if (skipToast) {
            if (toastId.current) {
                toast.dismiss(toastId.current);
                toastId.current = null;
            }
            return;
        }

        if (toastId.current) {
            toast.update(toastId.current, {
                render: (
                    <PlayAudioPopUp
                        selectedAudio={selectedAudio}
                        setIsPlay={setIsPlay}
                        icon={<FaPause className="text-primary m-auto" />}
                    />
                ),
            });
        } else {
            setIsPopupClosedByUser(false); // reset when user scroll
            toastId.current = toast.info(
                <PlayAudioPopUp
                    selectedAudio={selectedAudio}
                    setIsPlay={setIsPlay}
                    icon={<FaPause className="text-primary m-auto" />}
                />,
                {
                    icon: false,
                    autoClose: false,
                    closeButton: true,
                    position: "bottom-right",
                    toastId: "audio-play",
                    containerId: "audio",
                    closeOnClick: false,
                    onClose: () => {
                        toastId.current = null;

                        if (!closedByScroll.current) {
                            setIsPopupClosedByUser(true); // set flag when user close
                        }

                        closedByScroll.current = false; // reset when user close
                    },
                }
            );
        }
    } else {
        if (audioRef.current) {
            audioRef.current.pause();
            if (toastId.current) {
                toast.update(toastId.current, {
                    render: (
                        <PlayAudioPopUp
                            selectedAudio={selectedAudio}
                            setIsPlay={setIsPlay}
                            icon={<FaPlay className="text-primary m-auto" />}
                        />
                    ),
                });
            }
        }
    }
}
const AudioHelper = { handlePlayAudio };
export default AudioHelper;